import { Pouzivatel } from '../model/iam/Pouzivatel';
import { ClientStatus } from '../model/ClientStatus';
import Uuid from '../model/Uuid';
import { useClientFetch } from '../context/ClientStatusContext';
import { fetchZodpovednyPredkladatel } from '../client/legislativnyMaterial/zodpovednyPredkladatelClient';

interface ReturnType {
  pouzivatelia: Pouzivatel[];
  pouzivateliaStatus: ClientStatus;
}

export default (userUuid: Uuid, execute = true): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(fetchZodpovednyPredkladatel, [userUuid, execute], []);
  return {
    pouzivatelia: data,
    pouzivateliaStatus: status,
  };
};
